module.exports = __webpack_public_path__ + "static/img/5.67057dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/5.png
// module id = 4gKp
// module chunks = 0